import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import {
  FwButtonComponent,
  FwContainedInputComponent,
  FwDialogActionsComponent,
  FwDialogComponent,
  FwDialogContentComponent,
  FwDialogHeaderComponent,
  FwIconComponent,
  FwMenuItemComponent,
  FwSelectMenuComponent,
  FwTextInputComponent,
  FwTooltipDirective,
  FwWrappedInputComponent,
} from '@flywheel-io/vision';

import { MaterialModule } from '../material.module';
import { FeatureIfDirective } from '../shared/directives/feature-if.directive';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { AdminService } from './admin.service';
import { AppRegistrationDialogComponent } from './applications/app-registration-dialog.component';
import { AddDeviceDialog } from './devices/add-device-dialog/add-device-dialog.component';
import { AddDicomPeerDialog } from './devices/add-dicom-peer-dialog/add-dicom-peer-dialog.component';
import { RolesService } from './roles/roles.service';
import { AddPermissionsDialogComponent } from './users/add-permissions-dialog/add-permissions-dialog.component';
import { CreateUserDialogComponent } from './users/create-user-dialog/create-user-dialog.component';
import { UserInformationComponent } from './users/user-information/user-information.component';
import { DeleteTaskPreviewDialogComponent } from './viewer-protocols/delete-task-preview/delete-task-preview-dialog.component';
import { ViewerProtocolEditorDialogComponent } from './viewer-protocols/viewer-protocols-list/viewer-protocol-editor/viewer-protocol-editor-dialog.component';
import { ViewerProtocolsListComponent } from './viewer-protocols/viewer-protocols-list/viewer-protocols-list.component';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    FeatureIfDirective,
    FormsModule,
    FwButtonComponent,
    FwContainedInputComponent,
    FwDialogActionsComponent,
    FwDialogComponent,
    FwDialogContentComponent,
    FwDialogHeaderComponent,
    FwIconComponent,
    FwMenuItemComponent,
    FwSelectMenuComponent,
    FwTextInputComponent,
    FwTooltipDirective,
    FwWrappedInputComponent,
    MaterialModule,
    MatSelectModule,
    PipesModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [DeleteTaskPreviewDialogComponent, ViewerProtocolsListComponent],
  declarations: [
    AddDeviceDialog,
    AddDicomPeerDialog,
    AddPermissionsDialogComponent,
    AppRegistrationDialogComponent,
    CreateUserDialogComponent,
    DeleteTaskPreviewDialogComponent,
    ViewerProtocolEditorDialogComponent,
    ViewerProtocolsListComponent,
    UserInformationComponent,
  ],
  providers: [AdminService, RolesService],
})
export class AdminModule {}
